export const MOBILE_WIDTH = 414
export const MOBILE_HEIGHT = 460
export const DESKTOP_WIDTH = 1440
export const DESKTOP_HEIGHT = 640
